import Model, { attr, belongsTo, hasMany } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type SchoolClass from 'district-ui-client/models/school-class'
import type School from 'district-ui-client/models/school'
import type SubscriptionCoordinator from 'district-ui-client/models/subscription-coordinator'
import type TeacherSubscription from 'district-ui-client/models/teacher-subscription'
import type { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import { join } from 'district-ui-client/utils/uri'
import config from 'district-ui-client/config/environment'
import type StringTransform from 'district-ui-client/transforms/string'

export default class Teacher extends Model {
  @attr<StringTransform>('string') declare firstName: string

  @attr<StringTransform>('string') declare lastName: string

  @attr<StringTransform>('string') declare login: string

  @attr<StringTransform>('string') declare email: string

  @belongsTo<School>('school', { async: false, inverse: 'teachers' }) declare school?: School

  @hasMany<SchoolClass>('school-class', { async: false, inverse: 'teachers' }) declare schoolClasses?: SchoolClass[]

  @hasMany<SubscriptionCoordinator>('subscription-coordinator', { async: false, inverse: 'teacher' })
  declare subscriptionCoordinators: SubscriptionCoordinator[]

  @hasMany<TeacherSubscription>('teacher-subscription', { async: false, inverse: 'teacher' })
  declare teacherSubscriptions: TeacherSubscription[]

  teacherSubscriptionsFor(subscriptionType: SubscriptionType) {
    return this.teacherSubscriptions.filter((sub) => sub.subscriptionType === subscriptionType)
  }

  get schoolName() {
    return this.school?.name ?? ''
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  get fullNameReversed() {
    return `${this.lastName}, ${this.firstName}`
  }

  get possessiveFullName() {
    return `${this.firstName} ${this.lastName}'s`
  }

  // subco login path uses SSO login defined in readineggs/app/controllers/api/v1/district_ui/subco_logins_controller.rb
  get subcoLoginPath() {
    if (!this.id) throw new Error('you cannot construct a subcoLoginPath new records (records without an id)')
    return join(config.readingEggsV1Url, 'district_ui', 'subco_logins', this.id).href
  }

  [Type] = 'teacher' as const
}
